import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {FaFilter ,IoSearchSharp ,MdOutlineCancel ,BiReset} from "../../utils/icons"
import { DLabel, DSpinButton, Select } from '../../utils/Form'
function Fillter({titleAr,setTitleAr,titleEn,setTitleEn,date,setDate,categoryId,setCategoryId,AllCategory}) {
    const { t } = useTranslation()
    const [open ,setOpen]=useState(false)
    const [ftitleAr,setFtitleAr]=useState("")
    const [ftitleEn,setFtitleEn]=useState("")
    const [fdate,setFdate]=useState("")
    const [fcategoryId,setFcategoryId]=useState( categoryId && categoryId || "")


    const handeleSearsh =() =>{
if (titleAr !== null) {
    setTitleAr(ftitleAr)
    }

if (titleEn  !== null) {
    setTitleEn(ftitleEn)
    }
if (date !== null) {
    setDate(fdate)
    }
if (AllCategory && AllCategory.length>0) {
    setCategoryId(fcategoryId)
    }

}
 const handelReset =() =>{
    if (titleAr !== null) {
        setTitleAr("")
        }
    if (titleEn  !== null) {
        setTitleEn("")
        }
    if (date !== null) {
        setDate("")
        }
    if (AllCategory && AllCategory.length>0) {
        setCategoryId("")
        }
        
    }
  return (
    <div className='flex  items-center relative flex-col ' >
        <button className=' border bg-n-1 dark:bg-back-darktertiary border-color-1 dark:border-tcolor-2 px-5 py-1 flex flex-row items-center justify-center gap-3 rounded-lg'
        onClick={()=>setOpen(true)}
        >

              <h2 className='h5 dark:text-tcolor-2  text-color-1'>{t("Filter")}</h2>
        <FaFilter size={25} className='text-color-1 dark:text-tcolor-2' /></button>
{
   open &&    
    (<div className="nav-item   absolute border border-gray-200  top-16 bg-white p-8 rounded-lg w-80">
        <button className='p-2 rounded-full text-color-1 my-4 bg-n-1 hover:bg-n-2'
        onClick={()=>setOpen(false)}
        >
<MdOutlineCancel  size={25}/>
        </button>
  { titleAr  !== null  &&
   <DLabel
   labelText="Title (Ar)"
   value={ftitleAr}
   onChange={(e)=> {setFtitleAr(e.target.value)}}
   required={true}
   type="text"
   name="titleAr"
 />
  }
         
            { titleEn !== null  &&
                 <DLabel
                 labelText="Title (En)"
                 value={ftitleEn}
                 onChange={(e)=> {setFtitleEn(e.target.value)}}
                 required={true}
                 type="text"
                 name="titleAr"
               />
            }
            
          {
date !== null &&
<DLabel
              labelText="Date"
              value={fdate}
              onChange={(e)=> {setFdate(e.target.value)}}
              required={true}
              type="date"
              name="Date"
            />
          }  
{
    AllCategory && AllCategory.length>0 && 
    <Select Data={AllCategory} labelText={("Select Category")} value={fcategoryId} setValue={setFcategoryId} required={false} />
}
<div className=" flex flex-row gap-3 py-4 border-t-2 border-gray-200 justify-center items-center">  <DSpinButton 
     onClick={handeleSearsh}
       bgColor={"text-white   bg-gradient-to-r from-blue-600 via-blue-700 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300  shadow-lg shadow-blue-600/50 "}
       borderColor={"border-none"}
       fillColor={"fill-n-1"}
     > <span className='flex flex-row gap-2'>{t("Search")}
     <IoSearchSharp size={22} className='text-white' /></span> 
     </DSpinButton>
      
      <DSpinButton 
     onClick={handelReset}
     bgColor={"text-white  bg-gradient-to-r from-red-600 via-red-700 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300  shadow-lg shadow-red-600/50 "}
     borderColor={"border-none"}
     fillColor={"fill-n-1"}
     > <span className='flex flex-row gap-2'>{t("Reset")}
     <BiReset size={22} className='text-white ' /></span> </DSpinButton>
      </div>
   
    </div>)
}

     
      
    </div>
  )
}

export default Fillter